/**! Nutrition Tracker App
 * @namespace {object} nt */

// Namespace everything in a `nt` object to prevent polluting the global namespace.
var nt = {
    Models: {},
    Collections: {},
    Views: {},
    Router: {},
    Plugin: {},
    Option: {},
    preloader: '<div class="spinnerContainer">Loading <div class="spinner"></div> Please Wait'
};
